module.exports = __webpack_public_path__ + "img/nav-icon-1.01622d10.png";